/* @flow */

import React, { Component } from 'react';
import { Item, Button, Input, Form } from 'semantic-ui-react';

type Props = {
  block: EditorialTitleBlock,
  onSerialize?: (block: EditorialTextBlock) => void,
  onCanSubmitChanged?: (value: boolean) => void,
};

class Edit extends Component {
  props: Props;

  componentDidMount() {
    const { onCanSubmitChanged, block } = this.props;
    onCanSubmitChanged(block.content);
  }

  toggleHeaderButton = level => {
    this.props.onCanSubmitChanged(this.props.block.content);
    this.props.onSerialize({
      ...this.props.block,
      level,
    });
  };

  toggleH1 = () => {
    this.toggleHeaderButton('h1');
  };
  toggleH2 = () => {
    this.toggleHeaderButton('h2');
  };
  toggleH3 = () => {
    this.toggleHeaderButton('h3');
  };

  onInputChange = (event: SyntheticEvent) => {
    if (event.target instanceof HTMLInputElement) {
      const { value } = event.target;

      this.props.onCanSubmitChanged(value && value.length);

      this.props.onSerialize({
        ...this.props.block,
        content: value,
      });
    }
  };

  render() {
    const { block } = this.props;

    return (
      <Item.Content>
        <Button.Group style={{ marginBottom: '10px' }}>
          <Button
            type="button"
            onClick={this.toggleH1}
            active={!block.level || block.level === 'h1'}
          >
            Titre 1
          </Button>
          <Button
            type="button"
            onClick={this.toggleH2}
            active={block.level === 'h2'}
          >
            Titre 2
          </Button>
          <Button
            type="button"
            onClick={this.toggleH3}
            active={block.level === 'h3'}
          >
            Titre 3
          </Button>
        </Button.Group>
        <Form>
          <Form.Field>
            <label>Titre</label>
            <Input
              fluid
              placeholder="Titre"
              defaultValue={block.content}
              onChange={this.onInputChange}
            />
          </Form.Field>
        </Form>
      </Item.Content>
    );
  }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/modules/edito/plugins/title/Edit.js